import gql from "graphql-tag";
import { auditTableConfigFragment } from "./fragments";

/**
 * Update the audit configuration for a single table on the Orcha database.
 *
 * Routed to the Orcha subgraph by the Apollo gateway.
 */
export const UPDATE_ORCHA_AUDIT_TABLE_CONFIG = gql`
  mutation updateOrchaAuditTableConfig(
    $schemaName: String!
    $tableName: String!
    $isEnabled: Boolean!
    $excludeColumns: [String!]!
  ) {
    updateAuditTableConfig(
      schemaName: $schemaName
      tableName: $tableName
      isEnabled: $isEnabled
      excludeColumns: $excludeColumns
    ) {
      ...AuditTableConfigFragment
    }
  }
  ${auditTableConfigFragment}
`;

/**
 * Update the audit configuration for a single table on the Fides database.
 *
 * Served by the Fides subgraph. Until the Fides audit migrations
 * are ported from Orcha, this mutation rejects writes explicitly.
 */
export const UPDATE_FIDES_AUDIT_TABLE_CONFIG = gql`
  mutation updateFidesAuditTableConfig(
    $schemaName: String!
    $tableName: String!
    $isEnabled: Boolean!
    $excludeColumns: [String!]!
  ) {
    updateFidesAuditTableConfig(
      schemaName: $schemaName
      tableName: $tableName
      isEnabled: $isEnabled
      excludeColumns: $excludeColumns
    ) {
      ...AuditTableConfigFragment
    }
  }
  ${auditTableConfigFragment}
`;
